<template>
  <div class="container-fluid border-none py-5">
    <!-- Show tabs for all OLT types -->
    <ul class="nav nav-tabs d-flex justify-content-start w-auto" v-if="(data?.olt_modes == 'GPON' && data?.olt_brands == 'VSOL') || (data?.olt_modes == 'GPON' && data?.olt_brands == 'BDCOM') || (data?.olt_modes == 'GPON' && data?.olt_brands == 'CDATA-GPON-CLOUDE-V1') || (data?.olt_modes == 'EPON' && data?.olt_brands == 'CDATA-V1.2') || (data?.olt_modes == 'EPON' && data?.olt_brands == 'CDATA-CLOUDE-EPON') || (data?.olt_modes == 'EPON' && data?.olt_brands == 'VSOL') || (data?.olt_modes == 'EPON' && data?.olt_brands == 'BDCOM')">
      <li class="nav-item">
        <a class="nav-link" :class="{ active: activeTab === 'onu' }" @click="switchTab('onu')">OLT Info</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :class="{ active: activeTab === 'olt' }" @click="switchTab('olt')">Port Info</a>
      </li>
      <li class="nav-item" v-if="(data?.olt_modes == 'GPON' && data?.olt_brands == 'VSOL') || (data?.olt_modes == 'GPON' && data?.olt_brands == 'BDCOM') || (data?.olt_modes == 'EPON' && data?.olt_brands == 'VSOL')">
        <a class="nav-link" :class="{ active: activeTab === 'uplink' }" @click="switchTab('uplink')">Uplink Port Info</a>
      </li>
      <!-- New tab for BDCOM Port Status -->
      <li class="nav-item" v-if="(data?.olt_modes == 'GPON' && data?.olt_brands == 'BDCOM') || (data?.olt_modes == 'EPON' && data?.olt_brands == 'BDCOM')">
        <a class="nav-link" :class="{ active: activeTab === 'portstatus' }" @click="switchTab('portstatus')">Port Status</a>
      </li>
    </ul>
    <div class="row p-0 m-0">
      <!-- Left Side: Two stacked boxes -->
      <div
        class="col-md-3 d-flex flex-column p-0 m-0"
        style="padding-right: 30px !important; row-gap: 30px !important"
      >
        <!-- First box -->
        <div class="_card" >
          <template v-if="loading">
            <Skalaton />
          </template>
          <template v-else>
            <div class="tabs-container">
              
              <!-- OLT Info Tab Content -->
              <div v-if="activeTab === 'olt' || ((activeTab === 'uplink' || activeTab ==='portstatus') && ((data?.olt_modes == 'GPON'|| data?.olt_modes == 'EPON') && (data?.olt_brands == 'VSOL' || data?.olt_brands == 'BDCOM')))" class="tab-content">
              <h5 class="olt-info-header">
                  <span>OLT Info</span>
                  <span v-if="data?.olt_modes" class="badge bg-success text-white text-sm p-1 mx-1">{{ data.olt_modes }}</span>
                  <span v-if="data?.olt_brands" class="badge bg-success text-white text-sm p-1 mx-1">{{ data.olt_brands }}</span>
                  <span
                    class="play-btn"
                    @click="openVideoPlayer"
                    title="Play Video"
                  >
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                      <circle cx="14" cy="14" r="14" fill="#82D616"/>
                      <polygon points="11,9 21,14 11,19" fill="#fff"/>
                    </svg>
                  </span>
                </h5>
                <p class="text-sm m-0 font-weight-bold">Olt Id : {{data?.oltid}}</p>
                <p class="text-sm m-0 font-weight-bold">Olt Name : {{data?.olt_name}}</p>
                <p class="text-sm m-0 font-weight-bold">IP : {{data?.olt_ip}}</p>
                <p class="text-sm m-0 font-weight-bold">Port : {{data?.olt_port}}</p>
                <p class="text-sm m-0 font-weight-bold">Branch : {{data?.Branch_olt}}</p>                
              </div>

              <!-- PON Optical Power Tab Content -->
              <div v-if="activeTab === 'onu'" class="tab-content">
                <template v-if="loadingOltInfo">
                  <div class="text-center">
                    <div class="spinner-border spinner-border-sm" role="status"></div>
                    <span class="ms-2">Loading OLT Info...</span>
                  </div>
                </template>
                
                <!-- CDATA OLT Info in PON Optical Power Tab -->
                <template v-else-if="data?.olt_modes == 'EPON' && data?.olt_brands == 'CDATA-V1.2' && olt_info_data">
                  <h5>OLT Info</h5>
                  <CdataOltInfo :oltInfo="olt_info_data" />
                </template>

                <!-- VSOL System Info in PON Optical Power Tab -->
                <template v-else-if="activeTab === 'onu' && data?.olt_modes == 'GPON' && data?.olt_brands == 'VSOL' && vsolBasicInfo?.systeminfo">
                  <h5>System Information</h5>
                  <VsolSystemInfo :systemInfo="vsolBasicInfo.systeminfo" />
                </template>

                <!-- BDCOM GPON System Info in PON Optical Power Tab -->
                <template v-else-if="activeTab === 'onu' && data?.olt_modes == 'GPON' && data?.olt_brands == 'BDCOM' && bdcomBasicInfo">
                  <h5>System Information</h5>
                  <BdcomSystemInfo :systemInfo="bdcomBasicInfo" />
                </template>

                <!-- BDCOM EPON System Info in PON Optical Power Tab -->
                <template v-else-if="activeTab === 'onu' && data?.olt_modes == 'EPON' && data?.olt_brands == 'BDCOM' && bdcomEponBasicInfo">
                  <h5>System Information</h5>
                  <BdcomSystemInfo :systemInfo="bdcomEponBasicInfo" />
                </template>

                <!-- VSOL EPON System Info in PON Optical Power Tab -->
                <template v-else-if="activeTab === 'onu' && data?.olt_modes == 'EPON' && data?.olt_brands == 'VSOL' && vsolEponBasicInfo">
                  <h5>System Information</h5>
                  <VsolEponSystemInfo :systemInfo="vsolEponBasicInfo" />
                </template>

                <!-- EPON CDATA-EPON-CLODE System Info in PON Optical Power Tab -->
                <div v-else-if="data?.olt_modes == 'EPON' && data?.olt_brands == 'CDATA-CLOUDE-EPON' && eponClodeBasicInfo" >
                  <h5>System Information</h5>
                  <EponClodeSystemInfo :systemInfo="eponClodeBasicInfo" />
                </div>

                <!-- GPON CDATA-GPON-CLOUDE-V1 System Info in PON Optical Power Tab -->
                <template v-else-if="activeTab === 'onu' && data?.olt_modes == 'GPON' && data?.olt_brands == 'CDATA-GPON-CLOUDE-V1' && gponClodeBasicInfo">
                  <!-- <h5>System Information</h5> -->
                  <GponClodeSystemInfo :systemInfo="gponClodeBasicInfo" />
                </template>

                <template v-else>
                  <Skalaton />
                </template>
              </div>
            </div>
          </template>
        </div>

        <!-- Second box - Mikrotik Info (only in OLT Info tab) -->
        <div class="_card" v-if="activeTab == 'olt'">
          <template v-if="loading">
            <Skalaton />
          </template>
          <template v-else>
            <h5>Mikrotik Info</h5>
            <p class="text-sm m-0 font-weight-bold">IP : {{data?.Mikrotik_ip}}</p>
            <p class="text-sm m-0 font-weight-bold">Port : {{data?.m_port}}</p>
            <p class="text-sm m-0 font-weight-bold">Router Version: {{data?.routerv7 == false ? 6 : 7 }}+</p>
          </template>
        </div>
      </div>

      <!-- Right Side: Large box -->
      <div class="col-md-9 _card p-0 d-flex flex-row">
        <div class="w-100">
          <!-- OLT Controls Row -->
          <div class="d-flex justify-content-between align-items-center mx-3 py-2 flex-wrap olt-controls-row">
            <!-- Left controls: OLT + Clear + Sync -->
            <div class="d-flex align-items-center flex-nowrap g-3" >
              <h5 class=" mb-0 d-flex" style="padding-left: 0;">
                {{ getTableTitle() }}
                <button v-if="activeTab === 'olt'" class="badge denger-bg text-xs mx-2 p-2 cursor-pointer align-middle" @click="showConfirm = true">
                 CLEAR
                </button>
              </h5>
              <select
                v-if="activeTab === 'olt'"
                class="form-control invoice dark-filter my-2"
                style="min-width: 180px;"
                v-model="selectedSync"
              >
                <option value="">Sync All</option>
                <option
              v-for="(items, index) in sync_list"
              :key="index"
              :value="items.code"
                >
              {{ items.desc }}
                </option>
              </select>
              <button
                v-if="activeTab === 'olt'"
                class="badge bg-secondary text-xs mx-2 p-2 cursor-pointer align-middle"
                :disabled="syncing"
                @click="handleSync"
                style="margin-left: 8px;"
              >
                <span v-if="syncing">Syncing...</span>
                <span v-else>Sync</span>
              </button>
              <div v-if="syncMessage && activeTab === 'olt'" class="text-success my-2">{{ syncMessage }}</div>
            </div>

            <!-- Right controls: Refresh + Search + Port Group -->
            <div class="d-flex align-items-center flex-nowrap" >
              
                <span class="d-flex  badge bg-info text-white cursor-pointer" v-if="refreshing" @click="refreshCurrentTab"
                :disabled="refreshing">
                  <i class="fas fa-spinner fa-spin mx-1"></i> Refreshing...
                </span>
                <span class="d-flex badge bg-info text-white cursor-pointer" v-else @click="refreshCurrentTab"
                :disabled="refreshing">
                  <i class="fas fa-sync-alt mx-1"></i> Refresh
                </span>

              <!-- Status badges for OLT tab -->
              <div v-if="activeTab === 'olt' && filteredPorts && filteredPorts.length" class="d-flex align-items-center" style="gap: 8px; margin-left: 16px;">
                
                <span
                  class="badge bg-primary text-white cursor-pointer"
                  :class="{ 'border border-dark': statusFilter === '' }"
                  @click="statusFilter = ''"
                >
                  Total: {{ filteredPorts.length }}
                </span>
                <span
                  class="badge bg-success text-white cursor-pointer"
                  :class="{ 'border border-dark': statusFilter === 'online' }"
                  @click="statusFilter = 'online'"
                >
                  Online: {{ getOnlineCount() }}
                </span>
                <span
                  class="badge bg-danger text-white cursor-pointer"
                  :class="{ 'border border-dark': statusFilter === 'offline' }"
                  @click="statusFilter = 'offline'"
                >
                  Offline: {{ getOfflineCount() }}
                </span>
              </div>

              <!-- Search input for OLT tab -->
              <div v-if="activeTab === 'olt'" style="position: relative; min-width: 180px;"  >
                <input
                  type="text"
                  v-model="searchQuery"
                  class="form-control invoice m-2"
                  placeholder="Search..."
                  style="min-width: 180px;"
                  @focus="showSuggestions = true"
                  @blur="hideSuggestions"
                  @input="showSuggestions = true"
                />
                <ul v-if="showSuggestions && filteredDeregReasonSuggestions.length"
                    class="suggestion-dropdown"
                    style="position: absolute; z-index: 10; background: white; border: 1px solid #ccc; width: 100%; list-style: none; padding: 0; margin: 0; max-height: 200px; overflow-y: auto;">
                  <li v-for="(reason, idx) in filteredDeregReasonSuggestions"
                      :key="idx"
                      @mousedown.prevent="selectDeregReasonSuggestion(reason)"
                      style="padding: 8px; cursor: pointer; color: #181f2a;">
                    {{ reason }}
                  </li>
                </ul>
              </div>

              <!-- Port Group selector for OLT tab -->
              <select
                v-if="activeTab === 'olt'"
                class="form-control invoice dark-filter ml-3"
                style="min-width: 180px;"
                v-model="selectedPortGroup"
              >
                <option value="">Manage DB</option>
                <option
                  v-for="(items, key) in data?.ports_grouped"
                  :key="key"
                  :value="key"
                >
                  {{ key }}
                </option>
              </select>
            </div>
          </div>

          <div class="table-responsive p-0">
            <template v-if="loading">
              <Skalaton />
            </template>
            <template v-else>
              <!-- Loading states for each tab -->
              <div v-if="activeTab === 'onu' && loadingPonInfo" class="text-center p-4">
                <div class="spinner-border spinner-border-sm" role="status"></div>
                <span class="ms-2">Loading PON Information...</span>
              </div>

              <div v-if="activeTab === 'onu' && loadingGponClode" class="text-center p-4">
                <div class="spinner-border spinner-border-sm" role="status"></div>
                <span class="ms-2">Loading GPON CDATA-CLOUDE-V1 Information...</span>
              </div>

              <div v-if="activeTab === 'uplink' && loadingUplinkPonInfo" class="text-center p-4">
                <div class="spinner-border spinner-border-sm" role="status"></div>
                <span class="ms-2">Loading Uplink Information...</span>
              </div>

              <div v-if="activeTab === 'portstatus' && loadingPortStatus" class="text-center p-4">
                <div class="spinner-border spinner-border-sm" role="status"></div>
                <span class="ms-2">Loading Port Status...</span>
              </div>

              <!-- OLT Ports Table for all devices -->
              <OltPortsTable 
                v-if="activeTab === 'olt'" 
                :ports="filteredPorts" 
                @fetch-graph="fetchGraph"
                @confirm-delete="confirmDelete"
              />

              <!-- PON Optical Power Table for VSOL GPON -->
              <VsolPonTable 
                v-if="activeTab === 'onu' && data?.olt_modes == 'GPON' && data?.olt_brands == 'VSOL' && !loadingPonInfo"
                :vsolPonInfo="vsolPonInfo"
                :vsolBasicInfo="vsolBasicInfo"
                :loading="loadingPonInfo"
              />

              <!-- PON Optical Power Table for BDCOM GPON -->
              <BdcomGponPonTable 
                v-if="activeTab === 'onu' && data?.olt_modes == 'GPON' && data?.olt_brands == 'BDCOM' && !loadingPonInfo"
                :bdcomPonInfo="bdcomPonInfo"
                :bdcomBasicInfo="bdcomBasicInfo"
                :bdcomPortInfo="bdcomPortInfo"
                :loading="loadingPonInfo"
              />

              <!-- PON Optical Power Table for BDCOM EPON -->
              <BdcomEponPonTable 
                v-if="activeTab === 'onu' && data?.olt_modes == 'EPON' && data?.olt_brands == 'BDCOM' && !loadingPonInfo"
                :bdcomEponPonInfo="bdcomEponPonInfo"
                :loading="loadingPonInfo"
              />

              <!-- ONU Ports Table for CDATA EPON -->
              <CdataOnuTable 
                v-if="activeTab === 'onu' && data?.olt_modes == 'EPON' && data?.olt_brands == 'CDATA-V1.2' && !loadingOnuInfo"
                :onuInfo="onu_info_data"
                :loading="loadingOnuInfo"
              />

              <!-- VSOL EPON PON Table -->
              <VsolEponPonTable 
                v-if="activeTab === 'onu' && data?.olt_modes == 'EPON' && data?.olt_brands == 'VSOL' && !loadingPonInfo"
                :ponInfo="vsolEponPonInfo"
                :loading="loadingPonInfo"
              />

              <!-- VSOL Uplink Table -->
              <VsolUplinkTable 
                v-if="activeTab === 'uplink' && data?.olt_modes == 'GPON' && data?.olt_brands == 'VSOL' && !loadingUplinkPonInfo"
                :uplinkInfo="vsolUplinkPonInfo"
                :loading="loadingUplinkPonInfo"
              />

              <!-- BDCOM Uplink Table -->
              <BdcomGponUplinkTable 
                v-if="activeTab === 'uplink' && data?.olt_modes == 'GPON' && data?.olt_brands == 'BDCOM' && !loadingUplinkPonInfo"
                :uplinkInfo="bdcomUplinkPonInfo"
                :bdcomPortInfo="bdcomPortInfo"
                :loading="loadingUplinkPonInfo"
              />

              <!-- VSOL EPON Uplink Table -->
              <VsolEponUplinkTable 
                v-if="activeTab === 'uplink' && data?.olt_modes == 'EPON' && data?.olt_brands == 'VSOL' && !loadingUplinkPonInfo"
                :uplinkInfo="vsolEponUplinkPonInfo"
                :loading="loadingUplinkPonInfo"
              />

              <!-- BDCOM GPON Port Status Table -->
              <BdcomPortStatusTable 
                v-if="activeTab === 'portstatus' && data?.olt_modes == 'GPON' && data?.olt_brands == 'BDCOM' && !loadingPortStatus"
                :portInfo="bdcomPortInfo"
                :loading="loadingPortStatus"
              />

              <!-- BDCOM EPON Port Status Table -->
              <BdcomEponPortStatusTable 
                v-if="activeTab === 'portstatus' && data?.olt_modes == 'EPON' && data?.olt_brands == 'BDCOM' && !loadingPortStatus"
                :portInfo="bdcomEponPortInfo"
                :loading="loadingPortStatus"
              />

              <!-- EPON CDATA-EPON-CLODE Port Summary -->
              <div v-if="activeTab === 'onu' && data?.olt_modes == 'EPON' && data?.olt_brands == 'CDATA-CLOUDE-EPON' && !loadingEponClode" >
                <EponClodePortSummary :portData="eponClodePortInfo.port" 
                  :loading="loadingEponClode" />
              </div>

              <!-- GPON CDATA-GPON-CLOUDE-V1 Port Summary -->
              <div v-if="activeTab === 'onu' && data?.olt_modes == 'GPON' && data?.olt_brands == 'CDATA-GPON-CLOUDE-V1' && !loadingGponClode" >
                <GponClodePortSummary 
                  :portData="gponClodePortInfo" 
                  :overviewData="gponClodeOverviewInfo"
                  :loading="loadingGponClode" />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!-- Confirmation Modal -->
    <div v-if="showConfirm">
      <div class="popup_bg"></div>
      <div class="modal_class">
        <div class="modal-content invoice" style="width:25vw">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="font-weight-bold">Confirm Clear</span>
            <span @click="showConfirm = false" class="close">&times;</span>
          </div>
          <div class="my-3">
            Are you sure you want to clear this OLT data?
          </div>
          <div class="d-flex justify-content-end" style="gap: 10px;">
            <button class="btn btn-secondary btn-sm" @click="showConfirm = false">Cancel</button>
            <button class="btn btn-danger btn-sm" @click="confirmClear" :disabled="clearing">
              <span v-if="clearing">Clearing...</span>
              <span v-else>Clear</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Sync Status Modal -->
    <div v-if="showSyncStatus">
      <div class="popup_bg"></div>
      <div
      class="modal_class"
      >
      <div class="modal-content invoice" style="width:25vw" :style="syncStatusMsg && syncStatusMsg.status === 'error'
        ? 'border: 3px solid #dc3545 !important;'
        : syncStatusMsg && (syncStatusMsg.status === 'running' || syncStatusMsg.status === 'success' || syncStatusMsg.status === 'finished')
        ? 'border: 3px solid #28a745 !important;'
        : ''">
        <div class="d-flex justify-content-between align-items-center mb-2">
        <span class="font-weight-bold">Sync Status</span>
        <span @click="showSyncCloseConfirm = true" class="close">&times;</span>
        </div>
        <div class="my-3" style="word-break: break-all;">
        <div v-if="syncStatusHistory.length" class="text-lg-center">
          <div v-for="(msg, idx) in syncStatusHistory" :key="idx" class="d-flex align-items-center mb-2" style="gap: 8px;">
            <span v-if="idx !== syncStatusHistory.length - 1">
              <i class="fas fa-check-circle" style="color: #28a745;"></i>
            </span>
            <span v-else>
              <i v-if="msg.status === 'success' || msg.status === 'finished'" class="fas fa-check-circle" style="color: #28a745;"></i>
              <i v-else-if="msg.status === 'error'" class="fas fa-times-circle" style="color: #dc3545;"></i>
              <span v-else-if="msg.status === 'running'" class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
            </span>
            <span>
              <b>Status:</b> {{ msg.status }}
              <span v-if="msg.message"> - {{ msg.message }}</span>
              <span v-if="idx === syncStatusHistory.length - 1 && msg.status === 'finished' && syncStatusCountdown !== null">
                <i>Closing in {{ syncStatusCountdown }} second<span v-if="syncStatusCountdown !== 1">s</span>Waiting 10 minutes before sync...<span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span></i>
              </span>
            </span>
          </div>
        </div>
        <div v-else>
          {{ syncStatusMsg }}
        </div>
        </div>
        <div class="d-flex justify-content-end" style="gap: 10px;">
        <template v-if="syncStatusMsg && syncStatusMsg.status === 'error'">
          <button class="btn btn-danger btn-sm" @click="async () => { await getData(); showSyncStatus = false; }">Reload Page</button>
          <button class="btn btn-secondary btn-sm" @click="showSyncCloseConfirm = true">Close</button>
        </template>
        <template v-else>
          <button class="btn btn-secondary btn-sm" @click="showSyncCloseConfirm = true">Close</button>
        </template>
        </div>
      </div>
      </div>
    </div>

    <!-- Sync Status Close Confirmation Modal -->
    <div v-if="showSyncCloseConfirm">
      <div class="popup_bg"></div>
      <div class="modal_class">
        <div class="modal-content invoice" style="width:25vw">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="font-weight-bold">Confirm Close</span>
            <span @click="showSyncCloseConfirm = false" class="close">&times;</span>
          </div>
          <div class="my-3">
            Are you sure you want to close the Sync Status popup?
          </div>
          <div class="d-flex justify-content-end" style="gap: 10px;">
            <button class="btn btn-secondary btn-sm" @click="showSyncCloseConfirm = false">Cancel</button>
            <button class="btn btn-danger btn-sm" @click="closeSyncStatusModal">Close</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Chart Popup -->
    <div class="col-12 text-end" v-if="chart_popup">
      <div class="popup_bg"></div>
      <div id="myModal" class="modal_class">
        <div class="modal-content invoice" style="max-width: 1000px !important; max-height: 80vh; overflow-y: auto;">
          <div class="d-flex justify-content-between">
            <span><b>PPPoE ID:</b> {{ selected_pppoe_id }}</span>
            <span @click="closeChartPopup" class="close">&times;</span>
          </div>
          <div class="hover-popup my-3">
            <div class="popup-content">
              <div class="card z-index-2 invoice-card" style="height: 450px">
                <div class="calendar">
                  <div class="calendar-item" :class="selected_date === 'All' ? 'selected' : ''">
                    <div @click="filterChartData('All')">
                      <div class="calendar-day"></div>
                      <div class="calendar-date pt-2">All</div>
                    </div>
                  </div>
                  <div class="calendar-item" v-for="(data, index) in logData" :key="index"
                       :class="selected_date === data.date ? 'selected' : ''">
                    <div @click="filterChartData(data.date)">
                      <div class="calendar-day">{{ data.date.split(", ")[1] }}</div>
                      <div class="calendar-date">{{ data.date.split(", ")[0] }}</div>
                    </div>
                  </div>
                </div>
                <gradient-graph-chart
                  v-if="chartData"
                  id="chart-line"
                  title="Chart"
                  description="<i class='fa fa-arrow-up text-success'></i>
                  <span class='font-weight-bold'>Chart </span>"
                  :chart="chartData"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Delete Confirmation Popup -->
    <div class="col-12 text-end" v-if="delete_popup">
      <div class="popup_bg"></div>
      <div id="deleteModal" class="modal_class" >
        <div class="modal-content invoice" style="max-width: 400px !important">
          <div class="d-flex justify-content-between">
            <span><b>Confirm Delete</b></span>
            <span @click="closeDeletePopup" class="close">&times;</span>
          </div>
          <div class="my-3">
            <p>Are you sure you want to delete this record?</p>
            <div class="d-flex justify-content-end gap-2">
              <button class="btn btn-secondary" @click="closeDeletePopup">Cancel</button>
              <button class="btn btn-danger" @click="deleteRecord">Delete</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Toast message -->
    <div v-if="showToast" class="custom-toast" :class="toastType">
      {{ toastMessage }}
    </div>

    <!-- Video Player Modal -->
    <div v-if="showVideoPlayer">
    <div class="popup_bg"></div>
    <div class="modal_class">
      <div class="modal-content invoice" style="width: 40vw; max-width: 600px;">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <span class="font-weight-bold">OLT Video Player</span>
          <span @click="showVideoPlayer = false" class="close">&times;</span>
        </div>
        <div>
          <video v-if="videoType === 'mp4' && videoUrl" controls autoplay style="width: 100%; border-radius: 8px;">
            <source :src="videoUrl" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <iframe
            v-else-if="videoType === 'youtube' && videoUrl"
            :src="youtubeEmbedUrl(videoUrl)"
            frameborder="0"
            allow="autoplay; encrypted-media"
            allowfullscreen
            style="width: 100%; height: 340px; border-radius: 8px;"
          ></iframe>
          <p v-else>Loading video...</p>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import { useOltDetailsApi } from "../services/olt_details.service";
import showSwal from '../mixins/showSwal';
import Skalaton from '@/components/Skalaton.vue';
import GradientGraphChart from '@/examples/Charts/GradientGraphChart.vue';
import { useSearchApi } from '../services/search.service';
import { usePortInfoApi } from '../services/port-info.service';
import { usePortInfoVsolGponApi } from '../services/port-info-vsol-gpon.service';
import { usePortInfoVsolEponApi } from '../services/port-info-vsol-epon.service';
import { usePortInfoBdComGponApi } from '../services/port-info-bdcom-gpon.service';
import { usePortInfoBdComEponApi } from '../services/port-info-bdcom-epon.service';
import { usePortInfoEponCDATACLODEApi } from '../services/port-info-epon-cdata-clode.service';
import { usePortInfoGponCDATACLODEV1Api } from '../services/port-info-gpon-cdata-clode-v1.service';
import deleteData from '../services/delete-data.service';

// Import components
import OltPortsTable from './components/OltDetails/OltPortsTable.vue';
import VsolPonTable from './components/OltDetails/VsolPonTable.vue';
import BdcomGponPonTable from './components/OltDetails/BdcomGponPonTable.vue';
import BdcomEponPonTable from './components/OltDetails/BdcomEponPonTable.vue';
import CdataOnuTable from './components/OltDetails/CdataOnuTable.vue';
import VsolSystemInfo from './components/OltDetails/VsolSystemInfo.vue';
import BdcomSystemInfo from './components/OltDetails/BdcomSystemInfo.vue';
import CdataOltInfo from './components/OltDetails/CdataOltInfo.vue';
import VsolUplinkTable from './components/OltDetails/VsolUplinkTable.vue';
import BdcomGponUplinkTable from './components/OltDetails/BdcomGponUplinkTable.vue';
import BdcomPortStatusTable from './components/OltDetails/BdcomPortStatusTable.vue';
import BdcomEponPortStatusTable from './components/OltDetails/BdcomEponPortStatusTable.vue';
import EponClodeSystemInfo from './components/OltDetails/EponClodeSystemInfo.vue';
import EponClodePortSummary from './components/OltDetails/EponClodePortSummary.vue';
import GponClodeSystemInfo from './components/OltDetails/GponClodeSystemInfo.vue';
import GponClodePortSummary from './components/OltDetails/GponClodePortSummary.vue';
import VsolEponSystemInfo from './components/OltDetails/VsolEponSystemInfo.vue';
import VsolEponPonTable from './components/OltDetails/VsolEponPonTable.vue';
import VsolEponUplinkTable from './components/OltDetails/VsolEponUplinkTable.vue';

export default {
  name: "OltDetails",
  components: {
    Skalaton,
    GradientGraphChart,
    OltPortsTable,
    VsolPonTable,
    CdataOnuTable,
    VsolSystemInfo,
    BdcomSystemInfo,
    CdataOltInfo,
    BdcomEponPonTable,
    VsolUplinkTable,
    BdcomGponUplinkTable,
    BdcomPortStatusTable,
    BdcomEponPortStatusTable,
    EponClodeSystemInfo,
    EponClodePortSummary,
    GponClodeSystemInfo,
    GponClodePortSummary,
    BdcomGponPonTable,
    VsolEponSystemInfo,
    VsolEponPonTable,
    VsolEponUplinkTable,
  },
  data() {
    return {
      data: null,
      olt_info_data: null,
      onu_info_data: null,
      vsolBasicInfo: null,
      vsolUplinkPonInfo: null,
      vsolPonInfo: null,
      bdcomBasicInfo: null,
      bdcomPortInfo: null,
      bdcomPonInfo: null,
      bdcomUplinkPonInfo: null,
      bdcomEponBasicInfo: null,
      bdcomEponPonInfo: null,
      bdcomEponPortInfo: null,
      eponClodeBasicInfo: null,
      eponClodePortInfo: null,
      gponClodeBasicInfo: null,
      gponClodePortInfo: null,
      gponClodeOverviewInfo: null,
      vsolEponBasicInfo: null,
      vsolEponPonInfo: null,
      vsolEponUplinkPonInfo: null,
      sync_list: null, 
      selectedSync: '',
      searchQuery: '',
      selectedPortGroup: '',
      clearing: false,
      showConfirm: false, 
      syncing: false,
      showSyncStatus: false,
      syncStatusMsg: null,
      syncStatusTimer: null,
      syncStatusCountdown: null,
      loading: false,
      loadingPonInfo: false,
      loadingEponClode: false,
      loadingGponClode: false,
      loadingPortStatus: false,
      // For graph popup
      chart_popup: false,
      selected_pppoe_id: '',
      selected_date: 'All',
      chartData: null,
      logData: [],
      // For delete
      delete_popup: false,
      delete_id: '',
      showToast: false,
      toastMessage: '',
      toastType: '',
      statusFilter: '',
      syncStatusHistory: [],
      showSyncCloseConfirm: false,
      syncStatusPollingActive: false,
      showSuggestions: false,
      showVideoPlayer: false,
      videoUrl: '',
      videoType: '',
      activeTab: 'onu',
      loadingOltInfo: false,
      loadingOnuInfo: false,
      loadingUplinkPonInfo: false,
      refreshing: false,
    };
  },
  computed: {
    filteredPorts() {
      if (!this.data) return [];
      let ports = [];
      if (this.selectedPortGroup && this.data.ports_grouped && this.data.ports_grouped[this.selectedPortGroup]) {
        ports = this.data.ports_grouped[this.selectedPortGroup];
      } else if (this.data.all_ports) {
        ports = this.data.all_ports;
      }
      // Filter by search query
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        ports = ports.filter(item => {
          return Object.values(item).some(val => {
            if (val === null || val === undefined) return false;
            return String(val).toLowerCase().includes(query);
          });
        });
      }
      // Filter by statusFilter
      if (this.statusFilter === 'online') {
        ports = ports.filter(item =>
          item.status === 'online' ||
          item.status === 'finished' ||
          item.status === 'success'
        );
      } else if (this.statusFilter === 'offline') {
        ports = ports.filter(item =>
          item.status === 'offline' ||
          item.status === 'error'
        );
      }
      return ports;
    },
    uniqueDeregReasons() {
      if (!this.data || !this.data.all_ports) return [];
      const reasons = this.data.all_ports
        .map(item => item.last_dereg_reason)
        .filter(Boolean);
      return [...new Set(reasons)];
    },
    filteredDeregReasonSuggestions() {
      if (!this.searchQuery) return [];
      return this.uniqueDeregReasons.filter(reason =>
        reason.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
  },
  methods: {
    async switchTab(tab) {
      this.activeTab = tab;
      
      // Only fetch data for the active tab if not already loaded
      if (this.data) {
        if (tab === 'onu') {
          await this.fetchOnuTabData();
        } else if (tab === 'uplink') {
          await this.fetchUplinkTabData();
        } else if (tab === 'portstatus') {
          await this.fetchPortStatusData();
        }
        // 'olt' tab data is already loaded in getData()
      }
    },

    async refreshCurrentTab() {
      if (this.refreshing) return;
      
      this.refreshing = true;
      
      try {
        switch (this.activeTab) {
          case 'olt':
            // Refresh main OLT data for Port Info tab
            await this.getData();
            break;
            
          case 'onu':
            // Refresh OLT Info/PON Optical Power tab - only refetch current tab APIs
            await this.fetchOnuTabData(true);
            break;
            
          case 'uplink':
            // Refresh Uplink Port Info tab - only refetch current tab APIs
            await this.fetchUplinkTabData(true);
            break;
            
          case 'portstatus':
            // Refresh Port Status tab - only refetch current tab APIs
            await this.fetchPortStatusData(true);
            break;
        }
        
        // Show success feedback
        this.showToastMessage(`${this.getTableTitle()} data refreshed successfully`, 'success');
      } catch (error) {
        console.error('Error refreshing data:', error);
        this.showToastMessage('Failed to refresh data', 'error');
      } finally {
        this.refreshing = false;
      }
    },

    async fetchOnuTabData(forceRefresh = false) {
      if (forceRefresh) {
        // Force refresh by resetting data and refetching
        if (this.data.olt_modes == "EPON" && this.data.olt_brands == "CDATA-V1.2") {
          this.olt_info_data = null;
          this.onu_info_data = null;
          await this.getOltInfoData();
          await this.getOnuInfoData();
        } else if (this.data.olt_modes == "GPON" && this.data.olt_brands == "VSOL") {
          this.vsolBasicInfo = null;
          this.vsolPonInfo = null;
          await this.getVsolBasicInfo();
          await this.getVsolPonInfo();
        } else if (this.data.olt_modes == "GPON" && this.data.olt_brands == "BDCOM") {
          this.bdcomBasicInfo = null;
          this.bdcomPonInfo = null;
          await this.getBdcomGponBasicInfo();
          await this.getBdcomPonInfo();
        } else if (this.data.olt_modes == "EPON" && this.data.olt_brands == "VSOL") {
          this.vsolEponBasicInfo = null;
          this.vsolEponPonInfo = null;
          await this.getVsolEponBasicInfo();
          await this.getVsolEponPonInfo();
        } else if (this.data.olt_modes == "EPON" && this.data.olt_brands == "CDATA-CLOUDE-EPON") {
          this.eponClodeBasicInfo = null;
          this.eponClodePortInfo = null;
          await this.getEponClodeData();
        } else if (this.data.olt_modes == "GPON" && this.data.olt_brands == "CDATA-GPON-CLOUDE-V1") {
          this.gponClodeBasicInfo = null;
          this.gponClodePortInfo = null;
          this.gponClodeOverviewInfo = null;
          await this.getGponClodeData();
        } else if (this.data.olt_modes == "EPON" && this.data.olt_brands == "BDCOM") {
          this.bdcomEponBasicInfo = null;
          this.bdcomEponPonInfo = null;
          await this.getBdcomEponBasicInfo();
          await this.getBdcomEponPonInfo();
        }
      } else {
        // Normal fetch (only if data doesn't exist)
        if (this.data.olt_modes == "EPON" && this.data.olt_brands == "CDATA-V1.2") {
          if (!this.olt_info_data) {
            await this.getOltInfoData();
          }
          if (!this.onu_info_data) {
            await this.getOnuInfoData();
          }
        } else if (this.data.olt_modes == "GPON" && this.data.olt_brands == "VSOL") {
          if (!this.vsolBasicInfo) {
            await this.getVsolBasicInfo();
          }
          if (!this.vsolPonInfo) {
            await this.getVsolPonInfo();
          }
        } else if (this.data.olt_modes == "GPON" && this.data.olt_brands == "BDCOM") {
          if (!this.bdcomBasicInfo) {
            await this.getBdcomGponBasicInfo();
          }
          if (!this.bdcomPonInfo) {
            await this.getBdcomPonInfo();
          }
        } else if (this.data.olt_modes == "EPON" && this.data.olt_brands == "VSOL") {
          if (!this.vsolEponBasicInfo) {
            await this.getVsolEponBasicInfo();
          }
          if (!this.vsolEponPonInfo) {
            await this.getVsolEponPonInfo();
          }
        } else if (this.data.olt_modes == "EPON" && this.data.olt_brands == "CDATA-CLOUDE-EPON") {
          if (!this.eponClodeBasicInfo || !this.eponClodePortInfo) {
            await this.getEponClodeData();
          }
        } else if (this.data.olt_modes == "GPON" && this.data.olt_brands == "CDATA-GPON-CLOUDE-V1") {
          if (!this.gponClodeBasicInfo || !this.gponClodePortInfo) {
            await this.getGponClodeData();
          }
        } else if (this.data.olt_modes == "EPON" && this.data.olt_brands == "BDCOM") {
          if (!this.bdcomEponBasicInfo) {
            await this.getBdcomEponBasicInfo();
          }
          if (!this.bdcomEponPonInfo) {
            await this.getBdcomEponPonInfo();
          }
        }
      }
    },

    async fetchUplinkTabData(forceRefresh = false) {
      if (forceRefresh) {
        // Force refresh by resetting data and refetching
        if (this.data.olt_modes == "GPON" && this.data.olt_brands == "VSOL") {
          this.vsolUplinkPonInfo = null;
          await this.getVsolUplinkPonInfo();
        } else if (this.data.olt_modes == "GPON" && this.data.olt_brands == "BDCOM") {
          this.bdcomUplinkPonInfo = null;
          await this.getBdcomUplinkPonInfo();
        } else if (this.data.olt_modes == "EPON" && this.data.olt_brands == "VSOL") {
          this.vsolEponUplinkPonInfo = null;
          await this.getVsolEponUplinkPonInfo();
        }
      } else {
        // Normal fetch (only if data doesn't exist)
        if (this.data.olt_modes == "GPON" && this.data.olt_brands == "VSOL") {
          if (!this.vsolUplinkPonInfo) {
            await this.getVsolUplinkPonInfo();
          }
        } else if (this.data.olt_modes == "GPON" && this.data.olt_brands == "BDCOM") {
          if (!this.bdcomUplinkPonInfo) {
            await this.getBdcomUplinkPonInfo();
          }
        } else if (this.data.olt_modes == "EPON" && this.data.olt_brands == "VSOL") {
          if (!this.vsolEponUplinkPonInfo) {
            await this.getVsolEponUplinkPonInfo();
          }
        }
      }
    },

    async fetchPortStatusData(forceRefresh = false) {
      if (forceRefresh) {
        // Force refresh by resetting data and refetching
        if (this.data.olt_modes == "GPON" && this.data.olt_brands == "BDCOM") {
          this.bdcomPortInfo = null;
          await this.getBdcomGponPortData();
        } else if (this.data.olt_modes == "EPON" && this.data.olt_brands == "BDCOM") {
          this.bdcomEponPortInfo = null;
          await this.getBdcomEponPortStatusData();
        }
      } else {
        // Normal fetch (only if data doesn't exist)
        if (this.data.olt_modes == "GPON" && this.data.olt_brands == "BDCOM") {
          if (!this.bdcomPortInfo) {
            await this.getBdcomGponPortData();
          }
        } else if (this.data.olt_modes == "EPON" && this.data.olt_brands == "BDCOM") {
          if (!this.bdcomEponPortInfo) {
            await this.getBdcomEponPortStatusData();
          }
        }
      }
    },

    getTableTitle() {
      if (this.activeTab === 'olt') return 'OLT';
      if (this.activeTab === 'onu') {
        if (this.data?.olt_modes == 'GPON' && this.data?.olt_brands == 'VSOL') return 'PON Optical Power';
        if (this.data?.olt_modes == 'GPON' && this.data?.olt_brands == 'BDCOM') return 'PON Optical Power';
        if (this.data?.olt_modes == 'GPON' && this.data?.olt_brands == 'CDATA-GPON-CLOUDE-V1') return '';
        if (this.data?.olt_modes == 'EPON' && this.data?.olt_brands == 'CDATA-V1.2') return 'PON Optical Power';
        if (this.data?.olt_modes == 'EPON' && this.data?.olt_brands == 'VSOL') return 'PON Optical Power';
        if (this.data?.olt_modes == 'EPON' && this.data?.olt_brands == 'BDCOM') return 'PON Optical Power';
        if (this.data?.olt_modes == 'EPON' && this.data?.olt_brands == 'CDATA-CLOUDE-EPON') return 'System & Port Info';
        return 'OLT Info';
      }
      if (this.activeTab === 'uplink') return 'Uplink Port Info';
      if (this.activeTab === 'portstatus') return 'Port Status';
      return '';
    },

    getOnlineCount() {
      if (!this.data || !this.data.all_ports) return 0;
      return this.data.all_ports.filter(item =>
        item.status === 'online' ||
        item.status === 'Online' ||
        item.status === 'finished' ||
        item.status === 'success'
      ).length;
    },

    getOfflineCount() {
      if (!this.data || !this.data.all_ports) return 0;
      return this.data.all_ports.filter(item =>
        item.status === 'offline' ||
        item.status === 'Offline' ||
        item.status === 'error'
      ).length;
    },

    async syncList() {
      try {
        const response = await useOltDetailsApi().oltSyncList();
        this.sync_list = response; 
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async getData() {
      this.loading = true;
      try {
        let response = await useOltDetailsApi().oltDetails(this.$route.params.id);

        this.data = response;
        this.loading = false;
        // Only fetch initial data for the active tab
        if (this.activeTab === 'onu') {
          await this.fetchOnuTabData();
        }

        // Check all_ports for offline ports with missing PPPOE_ID
        if (response && response.all_ports && Array.isArray(response.all_ports)) {
          await Promise.all(response.all_ports.map(async (port) => {
            if (
              (port.status === 'offline' || port.status === 'Offline' || port.status === 'error') &&
              (!port.PPPOE_ID || port.PPPOE_ID === '')
            ) {
              const currentPortNumber = port.port_number;
              try {
                const apiResponse = await useOltDetailsApi().oltPPPOEID(this.$route.params.id, currentPortNumber);
                const targetPort = response.all_ports.find(p => p.port_number === currentPortNumber);
                if (
                  targetPort &&
                  (!targetPort.PPPOE_ID || targetPort.PPPOE_ID === '') &&
                  Array.isArray(apiResponse) &&
                  apiResponse.length > 0 &&
                  apiResponse[0].PPPOE_ID
                ) {
                  targetPort.PPPOE_ID = apiResponse[0].PPPOE_ID;
                }
              } catch (e) {
                console.error(`Failed to fetch PPPOE_ID for port ${currentPortNumber}`, e);
              }
            }
          }));
        }

        this.data = response;

        
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.loading = false;
      }
    },

    async getVsolBasicInfo() {
      this.loadingOltInfo = true;
      try {
        let response = await usePortInfoVsolGponApi().getBasicInfo(this.$route.params.id);
        this.vsolBasicInfo = response;
      } catch (error) {
        console.error("Error fetching VSOL basic info:", error);
      } finally {
        this.loadingOltInfo = false;
      }
    },

    async getVsolPonInfo() {
      this.loadingPonInfo = true;
      try {
        let response = await usePortInfoVsolGponApi().getPonPortData(this.$route.params.id);
        this.vsolPonInfo = response;
      } catch (error) {
        console.error("Error fetching VSOL PON info:", error);
      } finally {
        this.loadingPonInfo = false;
      }
    },

    async getVsolUplinkPonInfo() {
      this.loadingUplinkPonInfo = true;
      try {
        let response = await usePortInfoVsolGponApi().getUpLinkData(this.$route.params.id);
        this.vsolUplinkPonInfo = response;
      } catch (error) {
        console.error("Error fetching VSOL PON info:", error);
      } finally {
        this.loadingUplinkPonInfo = false;
      }
    },

    async getBdcomGponBasicInfo() {
      this.loadingOltInfo = true;
      try {
        let response = await usePortInfoBdComGponApi().getBasicInfo(this.$route.params.id);
        // Extract system info from BDCOM response
        if (response && response.devices && response.devices.length > 0) {
          const device = response.devices[0];
          if (device.results && device.results.length > 0) {
            const systemInfoResult = device.results.find(result => result.type === 'systeminfo');
            if (systemInfoResult && systemInfoResult.ok) {
              this.bdcomBasicInfo = systemInfoResult.data;
            }
          }
        }
      } catch (error) {
        console.error("Error fetching BDCOM basic info:", error);
      } finally {
        this.loadingOltInfo = false;
      }
    },

    async getBdcomGponPortData() {
      this.loadingPortStatus = true;
      try {
        let response = await usePortInfoBdComGponApi().getPortData(this.$route.params.id);
        // Extract port data from BDCOM response
        if (response && response.devices && response.devices.length > 0) {
          const device = response.devices[0];
          if (device.results && device.results.length > 0) {
            const portStatusResult = device.results.find(result => result.type === 'portstatus');
            if (portStatusResult && portStatusResult.ok) {
              this.bdcomPortInfo = portStatusResult.data;
            }
          }
        }
      } catch (error) {
        console.error("Error fetching BDCOM port data:", error);
      } finally {
        this.loadingPortStatus = false;
      }
    },

    async getBdcomPonInfo() {
      this.loadingPonInfo = true;
      try {
        let response = await usePortInfoBdComGponApi().getPonPortData(this.$route.params.id);
        // Extract PON info from BDCOM response
        if (response && response.devices && response.devices.length > 0) {
          const device = response.devices[0];
          if (device.results && device.results.length > 0) {
            const ponInfoResult = device.results.find(result => result.type === 'ponport_status');
            if (ponInfoResult && ponInfoResult.ok) {
              this.bdcomPonInfo = ponInfoResult.data;
            }
          }
        }
      } catch (error) {
        console.error("Error fetching BDCOM PON info:", error);
      } finally {
        this.loadingPonInfo = false;
      }
    },

    async getBdcomUplinkPonInfo() {
      this.loadingUplinkPonInfo = true;
      try {
        let response = await usePortInfoBdComGponApi().getUpLinkData(this.$route.params.id);
        // Extract uplink info from BDCOM response
        if (response && response.devices && response.devices.length > 0) {
          const device = response.devices[0];
          if (device.results && device.results.length > 0) {
            const uplinkResult = device.results.find(result => result.type === 'uplinkportstatus');
            if (uplinkResult && uplinkResult.ok) {
              this.bdcomUplinkPonInfo = uplinkResult.data;
            }
          }
        }
      } catch (error) {
        console.error("Error fetching BDCOM uplink PON info:", error);
      } finally {
        this.loadingUplinkPonInfo = false;
      }
    },

    async getOltInfoData() {
      this.loadingOltInfo = true;
      try {
        let response = await usePortInfoApi().getOltInfo(this.$route.params.id);       
        this.olt_info_data = response;
      } catch (error) {
        console.error("Error fetching OLT info data:", error);
      } finally {
        this.loadingOltInfo = false;
      }
    },

    async getOnuInfoData() {
      this.loadingOnuInfo = true;
      try {
        let response = await usePortInfoApi().getOnuInfo(this.$route.params.id);       
        this.onu_info_data = response;
      } catch (error) {
        console.error("Error fetching ONU info data:", error);
      } finally {
        this.loadingOnuInfo = false;
      }
    },

    async getEponClodeData() {
      this.loadingEponClode = true;
      try {
        // Fetch basic system info
        this.eponClodeBasicInfo = await usePortInfoEponCDATACLODEApi().getEponClodeBasicInfo(this.$route.params.id);
        
        // Fetch port information
        this.eponClodePortInfo = await usePortInfoEponCDATACLODEApi().getEponClodePonPortData(this.$route.params.id);
      } catch (error) {
        console.error("Error fetching EPON CDATA-CLODE data:", error);
      } finally {
        this.loadingEponClode = false;
      }
    },

    async getGponClodeData() {
      this.loadingGponClode = true;
      try {
        // Fetch basic system info
        this.gponClodeBasicInfo = await usePortInfoGponCDATACLODEV1Api().getGponClodeBasicInfo(this.$route.params.id);
        
        // Fetch port information
        this.gponClodePortInfo = await usePortInfoGponCDATACLODEV1Api().getGponClodePonPortData(this.$route.params.id);
        
        // Fetch overview information
        this.gponClodeOverviewInfo = await usePortInfoGponCDATACLODEV1Api().getGponClodePonPortOverViewData(this.$route.params.id);
      } catch (error) {
        console.error("Error fetching GPON CDATA-CLOUDE-V1 data:", error);
      } finally {
        this.loadingGponClode = false;
      }
    },

    // VSOL EPON API methods
    async getVsolEponBasicInfo() {
      this.loadingOltInfo = true;
      try {
        let response = await usePortInfoVsolEponApi().getBasicInfo(this.$route.params.id);
        this.vsolEponBasicInfo = response;
      } catch (error) {
        console.error("Error fetching VSOL EPON basic info:", error);
      } finally {
        this.loadingOltInfo = false;
      }
    },

    async getVsolEponPonInfo() {
      this.loadingPonInfo = true;
      try {
        let response = await usePortInfoVsolEponApi().getPonPortData(this.$route.params.id);
        this.vsolEponPonInfo = response;
      } catch (error) {
        console.error("Error fetching VSOL EPON PON info:", error);
      } finally {
        this.loadingPonInfo = false;
      }
    },

    async getVsolEponUplinkPonInfo() {
      this.loadingUplinkPonInfo = true;
      try {
        let response = await usePortInfoVsolEponApi().getUpLinkData(this.$route.params.id);
        this.vsolEponUplinkPonInfo = response;
      } catch (error) {
        console.error("Error fetching VSOL EPON uplink PON info:", error);
      } finally {
        this.loadingUplinkPonInfo = false;
      }
    },

    async getBdcomEponBasicInfo() {
      this.loadingOltInfo = true;
      try {
        let response = await usePortInfoBdComEponApi().getBasicInfo(this.$route.params.id);
        // BDCOM EPON response structure: { results: [{ data: {...}, ok: true }], type: "deviinfo" }
        if (response && response.results && response.results.length > 0) {
          const result = response.results[0];
          if (result.ok && result.data) {
            this.bdcomEponBasicInfo = result.data;
          }
        }
      } catch (error) {
        console.error("Error fetching BDCOM EPON basic info:", error);
      } finally {
        this.loadingOltInfo = false;
      }
    },

    async getBdcomEponPonInfo() {
      this.loadingPonInfo = true;
      try {
        let response = await usePortInfoBdComEponApi().getPonOpticalPowerData(this.$route.params.id);
        // BDCOM EPON response structure: { results: [{ data: [...], ok: true }], type: "eponopticaldiagnosis" }
        if (response && response.results && response.results.length > 0) {
          const result = response.results[0];
          if (result.ok && result.data && Array.isArray(result.data)) {
            this.bdcomEponPonInfo = result.data;
          }
        }
      } catch (error) {
        console.error("Error fetching BDCOM EPON PON info:", error);
      } finally {
        this.loadingPonInfo = false;
      }
    },

    async getBdcomEponPortStatusData() {
      this.loadingPortStatus = true;
      try {
        let response = await usePortInfoBdComEponApi().getPortStatusData(this.$route.params.id);
        // BDCOM EPON response structure: { results: [{ data: [...], ok: true }], type: "intfstate" }
        if (response && response.results && response.results.length > 0) {
          const result = response.results[0];
          if (result.ok && result.data && Array.isArray(result.data)) {
            this.bdcomEponPortInfo = result.data;
          }
        }
      } catch (error) {
        console.error("Error fetching BDCOM EPON port status data:", error);
      } finally {
        this.loadingPortStatus = false;
      }
    },

    async confirmClear() {
      if (this.clearing) return;
      this.clearing = true;
      try {
        await useOltDetailsApi().oltClear(this.$route.params.id);
        await this.getData();
        this.showConfirm = false;
      } catch (error) {
        this.showConfirm = false;
      } finally {
        this.clearing = false;
      }
    },

    async handleSync() {
      if (this.syncing) return;
      this.syncing = true;
      if (this.syncStatusTimer) {
        clearTimeout(this.syncStatusTimer);
        this.syncStatusTimer = null;
      }
      this.syncStatusPollingActive = true;
      this.syncStatusHistory = [];
      try {
        if (!this.selectedSync) {
          await useOltDetailsApi().oltSyncAll(
            this.data?.oltid,
            this.data?.olt_brands,
            this.data?.olt_modes
          );
        } else {
          await useOltDetailsApi().oltSync(
            this.data?.oltid,
            this.data?.olt_brands,
            this.selectedSync,
            this.data?.olt_modes
          );
        }
        showSwal.methods.showSwal({
          type: 'success',
          message: 'Sync successful!',
        });
        await this.getData();
      } catch (error) {
        showSwal.methods.showSwal({
          type: 'error',
          message: error?.message || 'Sync failed!',
        });
        console.error(error);
      } finally {
        const pollStatus = async () => {
          if (!this.syncStatusPollingActive) return;
          try {
            const status = await useOltDetailsApi().oltSyncStatus(this.$route.params.id);
            const last = this.syncStatusHistory[this.syncStatusHistory.length - 1];
            if (
              !last ||
              last.status !== status.status ||
              last.message !== status.message
            ) {
              this.syncStatusHistory.push({ ...status, timestamp: new Date() });
            }
            this.syncStatusMsg = status;
            this.showSyncStatus = true;
            if (this.syncStatusMsg.status === 'running' && this.syncStatusPollingActive) {
              this.syncStatusTimer = setTimeout(pollStatus, 5000);
            } else if (this.syncStatusMsg.status === 'finished') {
              this.syncStatusCountdown = 10;
              const countdownInterval = setInterval(() => {
                this.syncStatusCountdown--;
                if (this.syncStatusCountdown <= 0) {
                  clearInterval(countdownInterval);
                }
              }, 1000);
              this.syncStatusTimer = setTimeout(async () => {
                await this.getData();
                this.showSyncStatus = false;
                this.syncStatusTimer = null;
                this.syncStatusCountdown = null;
                this.syncStatusHistory = [];
              }, 10000);
            } else if (this.syncStatusMsg.status === 'error') {
              this.syncStatusTimer = null;
            }
          } catch (e) {
            this.syncStatusMsg = { message: 'Failed to fetch sync status.', status: 'error' };
            this.showSyncStatus = true;
            this.syncStatusTimer = null;
          }
        };
        pollStatus();
        this.syncing = false;
      }
    },

    async fetchGraph(pppoe_id) {
      this.selected_pppoe_id = pppoe_id;
      try {
        this.logData = await useSearchApi().getLogsDateList(pppoe_id);
        this.chart_popup = true;
        this.prepareChartData();
      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    },

    prepareChartData() {
      if (this.selected_date === 'All') {
        const description_data = this.logData.flatMap(dateObj =>
          dateObj.data.map(item => Number(item.description))
        );
        this.chartData = {
          labels: this.logData.flatMap(dateObj =>
            dateObj.data.map(item => `${item.last_update_formatted} (${item.description})`)
          ),
          datasets: [{
            label: '-dBm',
            data: description_data,
          }],
        };
      } else {
        const selectedDateData = this.logData.find(item => item.date === this.selected_date);
        if (selectedDateData) {
          const description_data = selectedDateData.data.map(item => Number(item.description));
          this.chartData = {
            labels: selectedDateData.data.map(item => 
              `${item.last_update_formatted} (${item.description})`
            ),
            datasets: [{
              label: '-dBm',
              data: description_data,
            }],
          };
        }
      }
    },

    filterChartData(date) {
      this.selected_date = date;
      this.prepareChartData();
    },

    closeChartPopup() {
      this.chart_popup = false;
      this.selected_date = 'All';
      this.chartData = null;
    },

    showToastMessage(msg, type) {
      this.toastMessage = msg;
      this.toastType = type;
      this.showToast = true;
      setTimeout(() => { this.showToast = false; }, 2000);
    },

    confirmDelete(pppoe_id) {
      if (!this.$options.hasPermission ? false : this.$options.hasPermission('2024')) {
        if (typeof this.hasPermission === 'function' && !this.hasPermission('2024')) {
          this.showToastMessage('You do not have permission to perform this action.', 'error');
          return;
        }
      } else if (typeof this.hasPermission === 'function' && !this.hasPermission('2024')) {
        this.showToastMessage('You do not have permission to perform this action.', 'error');
        return;
      }
      this.delete_id = pppoe_id;
      this.delete_popup = true;
    },

    closeDeletePopup() {
      this.delete_popup = false;
      this.delete_id = '';
    },

    async deleteRecord() {
      this.loading = true;
      try {
        await deleteData.deleteData(this.delete_id);
        this.showToastMessage('Record deleted successfully', 'success');
        await this.getData();
      } catch (error) {
        this.showToastMessage('Failed to delete record', 'error');
        console.error('Failed to delete record:', error);
      } finally {
        this.delete_popup = false;
        this.loading = false;
      }
    },

    closeSyncStatusModal() {
      this.showSyncStatus = false;
      this.syncStatusHistory = [];
      this.showSyncCloseConfirm = false;
      this.syncStatusPollingActive = false;
      if (this.syncStatusTimer) {
        clearTimeout(this.syncStatusTimer);
        this.syncStatusTimer = null;
      }
    },

    selectDeregReasonSuggestion(reason) {
      this.searchQuery = reason;
      this.showSuggestions = false;
    },

    hideSuggestions() {
      setTimeout(() => { this.showSuggestions = false; }, 100);
    },

    async openVideoPlayer() {
      this.showVideoPlayer = true;
      this.videoUrl = '';
      this.videoType = '';
      try {
        const response = await useOltDetailsApi().oltVideo();
        if (response && response.video_url) {
          this.videoUrl = response.video_url;
          if (this.videoUrl.includes('youtube.com') || this.videoUrl.includes('youtu.be')) {
            this.videoType = 'youtube';
          } else {
            this.videoType = 'mp4';
          }
        }
      } catch (e) {
        this.videoUrl = '';
        this.videoType = '';
      }
    },

    youtubeEmbedUrl(url) {
      let videoId = '';
      if (url.includes('youtube.com')) {
        const match = url.match(/[?&]v=([^&]+)/);
        videoId = match ? match[1] : '';
      } else if (url.includes('youtu.be')) {
        const match = url.match(/youtu\.be\/([^?&]+)/);
        videoId = match ? match[1] : '';
      }
      return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
    },
  },
  mounted() {
    this.getData();
    this.syncList();
  },
};
</script>

<style scoped>
/* Add any additional styles you need for the new VSOL EPON layout */
.port-info-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.port-info-card h6 {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 8px;
}

/* Clean tab styles - no borders */
.nav-tabs {
  border-bottom: none;
  margin-bottom: 15px;
}

.nav-tabs .nav-item {
  margin-bottom: 0;
}

.nav-tabs .nav-link {
  border: none;
  border-radius: 0;
  padding: 0.5rem 1rem;
  color: #495057;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  position: relative;
}

.nav-tabs .nav-link:hover {
  color: #0056b3;
  background-color: transparent;
}

.nav-tabs .nav-link.active {
  color: #0056b3;
  background-color: transparent;
  border: none;
  font-weight: 600;
}

/* Underline effect for active tab only */
.nav-tabs .nav-link.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #0056b3;
}

.tab-content {
  padding-top: 10px;
}

/* Dark mode support */
.dark-mode .nav-tabs .nav-link {
  color: #ccc;
}

.dark-mode .nav-tabs .nav-link:hover {
  color: #82D616;
}

.dark-mode .nav-tabs .nav-link.active {
  color: #82D616;
}

.dark-mode .nav-tabs .nav-link.active::after {
  background-color: #82D616;
}

/* Rest of your existing styles remain the same */
.border {
  border-width: 2px;
  border-style: solid;
}
.rounded {
  border-radius: 8px;
}

.text-white {
    color: #fff !important;
}

._card {
  border-radius: 10px;
  padding: 0px 15px;  
  padding-bottom: 10px;
  color: rgba(0, 0, 0, 0.589);
  display: flex;
  flex-direction: column;
  gap: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: visible;
}
._card .table-responsive {
  border-top-right-radius: 0 !important;
  overflow-x: auto;
}
._card .table-responsive::-webkit-scrollbar {
  height: 8px;
}
._cards {
  border-radius: 10px;
  padding: 20px;
  color: rgba(0, 0, 0, 0.589);
  display: flex;
  flex-direction: column;
  gap: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.dark-mode ._card {
  background-color: #061f3e;
}
.denger-bg {
  background-color: #dc3545 !important;
  color: #fff !important;
}
.popup_bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.modal_class {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1001;
  background: #181f2a;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.25);
  padding: 24px 24px 16px 24px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  scrollbar-width: none;
}
.modal_class::-webkit-scrollbar {
  display: none;
}
.close {
  cursor: pointer;
  font-size: 24px;
  font-weight: bold;
  color: #fff;
  margin-left: 16px;
}
.close:hover {
  color: #aaa;
}
.modal-content {
  max-width: 1000px !important;
  max-height: 80vh;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #444 transparent;
}
.modal-content::-webkit-scrollbar {
  width: 6px;
}
.modal-content::-webkit-scrollbar-thumb {
  background: #444;
  border-radius: 4px;
}
.modal-content::-webkit-scrollbar-track {
  background: transparent;
}
.invoice-card {
  height: 450px;
  overflow-y: auto;
  overflow-x: hidden;
}
.calendar {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0 20px 0;
  background: transparent;
  gap: 12px;
}
.calendar-item {
  min-width: 56px;
  height: 59px;
  background-color: #232b3e;
  color: #fff;
  text-align: center;
  border-radius: 10px;
  padding: 4px 8px;
  font-size: 14px;
  margin: 0;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px solid transparent;
}
.calendar-item.selected {
  background-color: #98ffcc;
  color: #181f2a;
  border: 2px solid #00c896;
  font-weight: bold;
}
.calendar-day {
  font-size: 12px;
}
.calendar-date {
  font-size: 20px;
  font-weight: bold;
}
@media (max-width: 600px) {
  .modal_class {
    max-width: 98vw;
    padding: 8px 2vw;
  }
  .calendar-item {
    min-width: 40px;
    height: 45px;
    font-size: 12px;
    padding: 2px 4px;
  }
  .calendar-date {
    font-size: 14px;
  }
}
.custom-toast {
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 2000;
  background: #222;
  color: #fff;
  padding: 14px 28px;
  border-radius: 8px;
  font-size: 1.1rem;
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
  opacity: 0.95;
  transition: all 0.3s;
}
.custom-toast.success {
  background: #82D616;
  color: #181f2a;
}
.custom-toast.error {
  background: #e74c3c;
  color: #fff;
}
.suggestion-dropdown {
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  border-radius: 0 0 8px 8px;
}
.suggestion-dropdown li:hover {
  background: #f0f0f0;
}
.play-btn:hover svg circle {
  fill: #5cb85c;
}
.olt-info-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 0;
  margin-bottom: 0;
}
.olt-info-header .badge {
  margin: 0 2px;
}
.olt-controls-row {
  gap: 12px;
}
@media (max-width: 900px) {
  .olt-controls-row {
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 10px;
  }
  .olt-controls-row > * {
    width: 100% !important;
    min-width: 0 !important;
    margin-bottom: 6px;
  }
}

/* Spinner styles */
.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}
.text-center {
  text-align: center;
}
</style>